import { Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Contact } from './Contact';
import { FundraisingServices } from './FundraisingServices';
import { Hero } from './Hero';
import { LetsDiscuss } from './LetsDiscuss';
import { startupPageSeo } from './startupPage.seo';
import type { HomepageProps } from './types';

export const StartupPage = ({ blogPosts }: HomepageProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...startupPageSeo} />

      <Hero />
      <FundraisingServices />
      <LetsDiscuss />
      <Contact color="orange" />
    </Layout>
  );
};
